import { makeAutoObservable, observable, toJS  } from "mobx";
import { ebendoDailyProductionService } from "../services/ebendodailyproductionservice";
import { saveAs } from "file-saver";
import moment from "moment";
import { getCurrentUser } from "../../../Utility/modules/helpers";
const _ = require("underscore");
class EbendoDailyProductionStore {
  constructor() {
    makeAutoObservable(this);
  }

  showEbendoDailyProductionDialog = false;
  dailyProductions = observable.map({});
  IsEquityProduction = 0;
  wellparameters = observable.map({});
  selTab = "1";
  showSQeryDialog = false;
  isDownloadingTemplate = false;
  isExporting = false;
  isSaving = false;
  isLoading = false;
  isLoaded = false;
  isLoadingDailyProd = false;
  wellParametersLoaded = false;
  sheetName = "Daily Report";
  showUploadErrorMessage = false;
  productionview = "gross";
  showRemarkPane = false;
  remarkObj = { title: "", remark: "<div></div>" };
  resultFromQuery = false;
  showWellAllocationExportDialog = false;
  exportOnlyWellAllocationVolume = false;
  view = "upload";
  uploadDate = moment(new Date()).format("DD-MMM-YYYY");
  gridHeaderText = `EBENDO JV(Gross) PRODUCTIONS from ${moment(new Date())
    .startOf("month")
    .format("ddd DD-MMM-YYYY")} to ${moment(new Date())
    .endOf("month")
    .format("ddd DD-MMM-YYYY")}`;
  initFormaData = {
    aseRiverExport: 0,
    aseRiverUptime: 0,
    bsw: 0,
    blpd: 0,
    crudeInjectionGGF: 0,
    ebendoDailyProductionId: 0,
    flareGas: 0,
    forcadosExport: 0,
    forcadosUptime: 0,
    fuelGas: 0,
    gas: 0,
    condensate: 0,
    gasSuppliedToGasPlant: 0,
    netProduction: 0,
    oil: 0,
    productionDate: moment(new Date())._d,
    stationDownHrs: 0,
    water: 0,
    stationAPI: 0,
    evacuatedCondensate: 0,

    remarks: "",
  };
  uploadErrors = [];
  selRow = {};
  queryCriteria = {
    startDate: moment(new Date())
      .startOf("month")
      .format("YYYY-MM-DDT00:00:00.000Z"),
    endDate: moment(new Date())
      .endOf("month")
      .format("YYYY-MM-DDT00:00:00.000Z"),
    fromInception: false,
    specificDate: false,
  };
  disableCommand = true;
  showEbendoRythmDrawer = false;
  async DownlaodDailyProductionTemplate() {
    try {
      this.isDownloadingTemplate = true;
      const res = await ebendoDailyProductionService.downloadTemplate();
      saveAs(res, "EbendoProductionTemplate.xlsx");
    } catch (error) {
      throw error;
    } finally {
      this.isDownloadingTemplate = false;
    }
  }
  async loadInitialWellParameters() {
    const retval =
      await ebendoDailyProductionService.getInitialWellParameters();

    if (retval.length) {
      this.wellparameters.clear();

      retval.forEach((para) => {
        this.wellparameters.set(para.ebendoDailyProductionWellId, para);
      });
      this.wellParametersLoaded = true;
    }
  }
  async loadProductions() {
    try {
      this.isLoading = true;
      let res = [];
      res = await ebendoDailyProductionService.loadProductionHistory(
        this.queryCriteria,
        this.productionview
      );
      console.log(res);
      this.dailyProductions.clear();
      res.prodHistory.forEach((prod) => {
        this.dailyProductions.set(prod.ebendoDailyProductionId, {
          ...prod,
          productionDate: moment(prod.productionDate).format("L"),
          strippedRemarks: prod.remarks
            ? prod.remarks.replace(/(<([^>]+)>)/gi, " ")
            : null,

          pdYear: moment(prod.productionDate).format("YYYY"),
          pdYearMonth: moment(prod.productionDate).format("YYYY-MMM"),
        });
      });

      this.isLoaded = true;

      return res;
    } catch (error) {
      throw error;
    } finally {
      this.isLoading = false;
    }
  }
  async saveDailyProduction(data) {
    try {
      this.isSaving = true;
      const uploadedBy = getCurrentUser()?.fullName;
      const res = await ebendoDailyProductionService.saveDailyProduction(
        {
          ...data,
          productionDate:
            data.productionDate.charAt(0) === "-"
              ? data.productionDate.substr(1)
              : data.productionDate,
        },
        [...this.wellparameters.values()],
        uploadedBy
      );
      console.log(res);
      return res;
    } catch (error) {
      throw error;
    } finally {
      this.isSaving = false;
    }
  }
  get isValidProductionData() {
    const { oil, gas, condensate } = toJS(this.initFormaData);
    return oil + gas + condensate >= 0;
  }

  async deleteProduction(id, prodDate) {
    try {
      const retVal = await ebendoDailyProductionService.deleteProduction(
        id,
        prodDate
      );
      return retVal;
    } catch (error) {
      throw error;
    }
  }
  clearFormValues() {
    let init = {
      aseRiverExport: 0,
      aseRiverUptime: 0,
      bsw: 0,
      blpd: 0,
      crudeInjectionGGF: 0,
      ebendoDailyProductionId: 0,
      flareGas: 0,
      forcadosExport: 0,
      forcadosUptime: 0,
      fuelGas: 0,
      gas: 0,
      condensate: 0,
      gasSuppliedToGasPlant: 0,
      netProduction: 0,
      oil: 0,
      productionDate: moment(new Date())._d,
      stationDownHrs: 0,
      water: 0,
      stationAPI: 0,
      evacuatedCondensate: 0,
      remarks: "",
    };
    this.initFormaData = init;
    this.uploadDate = moment(new Date())._d;
  }

  get totalBLPD() {
    const vals = _.map([...this.wellparameters.values()], (x) => toJS(x));
    let sum = vals.reduce((s, f) => Number(s) + Number(f.blpd), 0);
    this.initFormaData.blpd = sum;
    return sum;
  }

  async getWellContributions(pdate) {
    try {
      const retVal = await ebendoDailyProductionService.getWellContributions(
        pdate
      );
      return retVal;
    } catch (error) {
      throw error;
    }
  }
  async getEbendoDailyProductionById(productionId) {
    try {
      this.isLoadingDailyProd = true;
      const retVal =
        await ebendoDailyProductionService.getEbendoDailProductionById(
          productionId,
          this.IsEquityProduction
        );
      console.log(retVal);
      this.initFormaData = retVal;
    } catch (error) {
      throw error;
    } finally {
      this.isLoadingDailyProd = false;
    }
  }
  async exportWellAllocation(exportDate) {
    try {
      this.isExporting = true;
      const [startDate, endDate] = exportDate;
      const res = await ebendoDailyProductionService.exportWellAllocation(
        moment(startDate).format("MM/DD/YYYY"),
        moment(endDate).format("MM/DD/YYYY"),
        this.exportOnlyWellAllocationVolume
      );

      saveAs(res, "ebendo_well_allocation_export.xlsx",{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
    } catch (error) {
      throw error;
    } finally {
      this.isExporting = false;
    }
  }
}



const ebendoDailyProductionStore = new EbendoDailyProductionStore();
export default ebendoDailyProductionStore;

